var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchSavingsPlans32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Savings-Plans_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Savings-Plans_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Savings-Plans_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,16.792 L27.14,18.764 C27.056,18.822 26.956,18.852 26.855,18.852 C26.822,18.852 26.788,18.849 26.754,18.841 C26.619,18.813 26.503,18.731 26.432,18.615 L24.627,15.691 L25.477,15.168 L26.697,17.146 C26.843,16.4 26.941,15.645 26.941,14.879 C26.941,8.327 21.571,2.997 14.97,2.997 C8.368,2.997 2.998,8.327 2.998,14.879 C2.998,16.181 3.208,17.46 3.623,18.68 L2.678,19 C2.229,17.677 2,16.29 2,14.879 C2,7.778 7.818,2 14.97,2 C22.121,2 27.939,7.778 27.939,14.879 C27.939,15.641 27.865,16.398 27.732,17.145 L29.433,15.972 L30,16.792 Z M16.976,13.231 C18.464,14.239 22.417,16.916 22.417,21.526 C22.417,26.137 19.367,29.001 14.458,29.001 C9.55,29.001 6.5,26.137 6.5,21.526 C6.5,16.916 10.453,14.239 11.941,13.231 C12.075,13.141 12.188,13.064 12.276,13 L16.641,13 C16.729,13.064 16.842,13.141 16.976,13.231 L16.976,13.231 Z M12.546,9.739 C12.672,9.771 12.804,9.752 12.916,9.688 C12.985,9.648 13.028,9.623 14.502,8.126 L15.979,9.607 C16.104,9.731 16.283,9.783 16.454,9.739 L18.735,9.167 L16.57,12 L12.216,12 L10.191,9.149 L12.546,9.739 Z M25.211,12.074 C24.894,11.927 24.637,11.661 24.447,11.283 C24.075,10.541 23.562,10.353 23.195,10.326 C22.173,10.254 21.068,11.451 20.642,12.004 L17.827,12.004 L20.397,8.639 C20.526,8.47 20.534,8.238 20.418,8.06 C20.302,7.883 20.085,7.797 19.879,7.85 L16.486,8.7 L14.854,7.063 C14.76,6.969 14.633,6.916 14.5,6.916 L14.498,6.916 C14.365,6.917 14.237,6.97 14.144,7.065 C13.506,7.714 12.799,8.428 12.529,8.704 L9.121,7.85 C8.919,7.798 8.705,7.881 8.587,8.053 C8.469,8.226 8.471,8.454 8.593,8.625 L11.311,12.452 C9.795,13.479 5.5,16.46 5.5,21.526 C5.5,26.674 9.017,30 14.458,30 C19.9,30 23.417,26.674 23.417,21.526 C23.417,17.169 20.241,14.357 18.387,13 L20.895,13 C21.058,13 21.21,12.921 21.304,12.789 C21.738,12.174 22.577,11.296 23.122,11.32 C23.18,11.324 23.356,11.337 23.553,11.729 C23.842,12.305 24.27,12.737 24.789,12.977 L25.211,12.074 Z M16.5,23.437 C16.5,24.375 15.86,25.158 15,25.383 L15,21.57 C15.779,21.853 16.5,22.447 16.5,23.437 L16.5,23.437 Z M12.5,18.4 C12.5,17.463 13.14,16.68 14,16.454 L14,20.267 C13.221,19.984 12.5,19.39 12.5,18.4 L12.5,18.4 Z M11.5,18.4 C11.5,19.783 12.491,20.906 14,21.311 L14,25.383 C13.14,25.158 12.5,24.375 12.5,23.437 L11.5,23.437 C11.5,24.929 12.584,26.163 14,26.404 L14,26.888 L15,26.888 L15,26.404 C16.416,26.163 17.5,24.929 17.5,23.437 C17.5,22.054 16.509,20.931 15,20.526 L15,16.454 C15.86,16.68 16.5,17.463 16.5,18.4 L17.5,18.4 C17.5,16.909 16.416,15.674 15,15.433 L15,14.888 L14,14.888 L14,15.433 C12.584,15.674 11.5,16.909 11.5,18.4 L11.5,18.4 Z",
    id: "AWS-Savings-Plans_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchSavingsPlans32);
export default __webpack_public_path__ + "static/media/Arch_Savings-Plans_32.726ce743dfd55ce0667b3ff59ef6ea0d.svg";
export { ForwardRef as ReactComponent };